module.exports = __webpack_public_path__ + "assets/img/location_icon.108d58fc.svg";